<basic-report
[report]="this.reportVariant"
[reportName]="'Applications Report'"
[defaultDisplayColumns]="this.defaultDisplayColumns"
[dateFilterTypes]="this.dateFilters"
[groupByColumns] = "this.groupByColumns"
[getSummaryData]="this.getSummaryData"
>
</basic-report>
